import countries from "@server/CountriesList";
import { CustomerInput } from "@typings/Customer";
import { InputField } from "@typings/InputField";

class InputFields {
  FIELDS: InputField[] = [
    {
      name: "name",
      type: "string",
      label: "Customer",
      required: true,
    },
    {
      name: "email",
      type: "string",
      label: "Email",
      validate: (field: InputField) =>
        field.value
          ? /^\S.*@.*\..*\S$/.test(field.value) || "Incorrect email format"
          : true,
    },
    {
      name: "country",
      type: "string",
      label: "Country",
      enum: countries.map(c => ({ label: c.name, value: c.code })),
      noSelectionMessage: "Select a country",
    },
    {
      name: "department",
      type: "string",
      label: "Department",
    },
    {
      name: "contact",
      type: "string",
      label: "Contact Person",
    },
    {
      name: "description",
      type: "string",
      label: "Description",
    },
  ];

  buildData(fields: InputField[]): CustomerInput {
    const getValue = (name: string): any => {
      const field = fields.find(f => f.name === name);
      if (!field) {
        throw new Error(`Can't find field named '${name}'`);
      }
      return field.value;
    };

    return {
      name: getValue("name"),
      email: getValue("email"),
      country: getValue("country"),
      department: getValue("department"),
      contact: getValue("contact"),
      description: getValue("description"),
    };
  }
}

export default new InputFields();
